import React from 'react';
import LessonHome from '../LessonHome';

const Lesson4 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson4;